<template>
  <div :class="[className]"
       :style="{'padding-left': gutter+'rem','padding-right':gutter+'rem'}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: ""
    },
    gutter: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped="scoped">
</style>



// WEBPACK FOOTER //
// src/components/row/rowItem.vue